import dayjs from 'dayjs';
import { Journey, JourneyState, TimeWindow } from 'interfaces/journey';

// from y to ya están en la hora del centro; el instante solo hace falta para el estado.
export const scheduleRangeLabel = (schedule: TimeWindow) =>
  `${schedule.from}–${schedule.to}`;

// Go manda la fecha cero ("0001-01-01T00:00:00Z") cuando no la tiene.
export const isMissingDate = (date?: Date | string) =>
  !date || dayjs(date).year() < 2000;

// Rótulo y fecha del último cambio de estado grande. En transferencia se sigue mostrando
// "Iniciada" (mismo startedDate): no hay una fecha propia de esa transición.
const stateChange = (journey: Journey): { label: string; date?: Date } => {
  switch (journey.state) {
    case JourneyState.Offered:
      return { label: 'Ofertada', date: journey.offeredDate };
    case JourneyState.Assigned:
      return { label: 'Ofrecida', date: journey.offeredDate };
    case JourneyState.Accepted:
      return { label: 'Aceptada', date: journey.acceptedDate };
    case JourneyState.Started:
    case JourneyState.Transfering:
      return { label: 'Iniciada', date: journey.startedDate };
    default:
      return { label: 'Creada', date: journey.creationDate };
  }
};

// Sin fecha propia (rutas de antes de guardarla, o la fecha cero) cae a la de creación.
export const getLastChange = (
  journey: Journey,
): { label: string; date?: Date } => {
  const { label, date } = stateChange(journey);
  if (!isMissingDate(date)) return { label, date };
  if (isMissingDate(journey.creationDate)) return { label: 'Creada' };
  return { label: 'Creada', date: journey.creationDate };
};
